import type { IconNode } from '../types';

/**
 * @name sunlounger-parasol-table
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMjEgOEgzbDktNloiIC8+CiAgPHBhdGggZD0iTTEyIDh2MTMiIC8+CiAgPHBhdGggZD0iTTggMTNoOCIgLz4KICA8cGF0aCBkPSJtMyAyMSAuNy0yLjFjLjItLjUuNy0uOSAxLjMtLjloMTJjLjUgMCAxLjMtLjQgMS42LS44TDIyIDEzIiAvPgogIDxwYXRoIGQ9Im0yMSAyMS0zLjItMy4yIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/sunlounger-parasol-table
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const sunloungerParasolTable: IconNode = [
  ['path', { d: 'M21 8H3l9-6Z', key: 'lj1hvn' }],
  ['path', { d: 'M12 8v13', key: '1c76mn' }],
  ['path', { d: 'M8 13h8', key: '1s9po7' }],
  ['path', { d: 'm3 21 .7-2.1c.2-.5.7-.9 1.3-.9h12c.5 0 1.3-.4 1.6-.8L22 13', key: '12dkjb' }],
  ['path', { d: 'm21 21-3.2-3.2', key: '13qymi' }],
];

export default sunloungerParasolTable;
